"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMoreOptions = void 0;
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevProductTreeNodes = [] } = (_a = previousResult.productTreeNodes) !== null && _a !== void 0 ? _a : {};
    const { productTreeNodes } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    const { edges = [] } = productTreeNodes, restProductTreeNodesInfo = __rest(productTreeNodes, ["edges"]);
    return {
        productTreeNodes: Object.assign(Object.assign({}, restProductTreeNodesInfo), { edges: [...prevProductTreeNodes, ...edges] }),
    };
};
exports.fetchMoreOptions = { updateQuery };
